"use strict";

var _interopRequireDefault = require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _react = _interopRequireDefault(require("react"));
var _click = _interopRequireDefault(require("../click"));
var _classNames = _interopRequireDefault(require("../classNames"));
var _Signature = _interopRequireDefault(require("../Signature"));
var _canvasToBlob = _interopRequireDefault(require("../canvasToBlob"));
var _dialog = _interopRequireDefault(require("../Modal/dialog"));
var _jsxFileName = "/Users/mweeb/Desktop/codings/nq-component/src/InputSignature/index.js";
function InputSignature(_ref) {
  var className = _ref.className,
    value = _ref.value,
    onChange = _ref.onChange,
    saveImage = _ref.saveImage,
    disabled = _ref.disabled;
  var canvasRef = _react["default"].useRef(null);
  var _React$useState = _react["default"].useState(0),
    _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
    progress = _React$useState2[0],
    setProgress = _React$useState2[1];
  var _React$useState3 = _react["default"].useState(null),
    _React$useState4 = (0, _slicedToArray2["default"])(_React$useState3, 2),
    image = _React$useState4[0],
    setImage = _React$useState4[1];
  function readImage(file) {
    var reader = new FileReader();
    reader.onload = function (e) {
      setImage(e.target.result);
    };
    reader.readAsDataURL(file);
  }
  function onFileSelected(file) {
    readImage(file);
    var options = {
      progress: function progress(value) {
        return setProgress(value * 100);
      }
    };
    saveImage.execute(file, options).then(function (result) {
      setImage(result.url);
      setProgress(0);
      onChange(result.url);
    })["catch"](function (error) {
      console.log('error', error);
    });
  }
  function onClick() {
    if (disabled) return;
    var input = document.createElement('input');
    input.type = "file";
    input.accept = 'img';
    input.onchange = function (e) {
      var _e$target$files = (0, _slicedToArray2["default"])(e.target.files, 1),
        file = _e$target$files[0];
      file && onFileSelected(file);
    };
    (0, _click["default"])(input);
  }
  function pinClick(e) {
    e.stopPropagation();
    _dialog["default"].fire({
      size: 'lg',
      html: /*#__PURE__*/_react["default"].createElement(_Signature["default"], {
        setRef: canvasRef,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 56,
          columnNumber: 21
        }
      }),
      positiveButton: 'SAVE',
      onPositiveClick: function onPositiveClick() {
        var dataURL = canvasRef.current.toDataURL('image/png');
        var canvas = canvasRef.current;
        setImage(dataURL);
        var options = {
          progress: function progress(value) {
            return setProgress(value * 100);
          }
        };
        (0, _canvasToBlob["default"])(canvas, 'signature', 'image/png').then(function (blob) {
          return saveImage.execute(blob, options);
        }).then(function (result) {
          setImage(result.url);
          setProgress(0);
          onChange(result.url);
        })["catch"](function (error) {
          console.log('error', error);
        });
      }
    });
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    onClick: onClick,
    className: (0, _classNames["default"])("rounded bg-light d-flex position-relative cursor-pointer", className),
    style: {
      height: "250px"
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 85,
      columnNumber: 9
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "position-absolute h-100 w-100 d-flex justify-content-center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 89,
      columnNumber: 13
    }
  }, /*#__PURE__*/_react["default"].createElement("img", {
    className: "img-fluid",
    src: image || value,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 90,
      columnNumber: 17
    }
  })), !(image || value) && /*#__PURE__*/_react["default"].createElement("div", {
    className: "position-absolute h-100 w-100 d-flex",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 97,
      columnNumber: 21
    }
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "bi bi-image display-3 text-muted m-auto",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 98,
      columnNumber: 25
    }
  })), progress > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: "position-absolute h-100 w-100 bg-black bg-opacity-50",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 103,
      columnNumber: 33
    }
  }), progress > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: "position-absolute h-100 w-100 d-flex",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 107,
      columnNumber: 21
    }
  }, /*#__PURE__*/_react["default"].createElement("h3", {
    className: "m-auto text-white",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 108,
      columnNumber: 25
    }
  }, progress.toFixed(0), "%")), /*#__PURE__*/_react["default"].createElement("div", {
    className: "position-absolute w-100 text-end p-2",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 112,
      columnNumber: 13
    }
  }, /*#__PURE__*/_react["default"].createElement("button", {
    disabled: disabled,
    type: "button",
    onClick: pinClick,
    className: "btn btn-secondary",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 113,
      columnNumber: 17
    }
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "bi bi-pencil",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 118,
      columnNumber: 21
    }
  }))));
}
var _default = exports["default"] = InputSignature;